export const SEND_MESSAGE = 'app/send_message'
